import React from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel, Box, Flex } from "@chakra-ui/react";
import ComponentFactory from "./Factory/ComponentFactory";
import ButtonComponent from "./ButtonComponent";

const TabsComponent = ({ content, readOnly, variant, lineColor, handleButtonAction, isTouchDevice, isMouseDevice }) => {
  if (!Array.isArray(content) || content.length === 0) {
    return <div>No tabs available</div>;
  }

  return (
    <Tabs isLazy variant={variant}>
      {/* Tab Headers */}
      <TabList
        overflowX="auto"
        whiteSpace="nowrap"
        borderBottom="1px solid var(--vibrant-purple-15)"
        display="flex"
        sx={{
          scrollbarWidth: "none",
          "-ms-overflow-style": "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {content.map((tabData, index) => (
          <Tab
            key={`tab-${index}`}
            flex="1"
            color="#5F1B93"
            borderBottom="4px solid #5F1B93"
            borderTopLeftRadius="6px"
            borderTopRightRadius="6px"
            fontFamily={`var(--${variant || 'body-md-min-bold'}-font-family, sans-serif)`}
            fontWeight={`var(--${variant || 'body-md-min-bold'}-font-weight, bold)`}
            fontSize={`var(--${variant || 'body-md-min-bold'}-font-size, 16px)`}
            textAlign="center"
            _selected={{
              backgroundColor: "#5F1B93",
              color: "white",
              borderBottom: "4px solid #5F1B93",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
              fontFamily: `var(--${variant || 'body-md-min-bold'}-font-family, sans-serif)`,
              fontWeight: `var(--${variant || 'body-md-min-bold'}-font-weight, bold)`,
              fontSize: `var(--${variant || 'body-md-min-bold'}-font-size, 16px)`,
              textAlign: "center",
            }}
            _focus={{ boxShadow: "none" }}
          >
            {tabData.label || `Step ${index + 1}`}
          </Tab>
        ))}
      </TabList>

      {/* Tab Panels */}
      <TabPanels>
        {content.map((tabData, tabIndex) => (
          <TabPanel key={`tabpanel-${tabIndex}`} px={0} py={4}>
            {Array.isArray(tabData.sections) && tabData.sections.length > 0 ? (
              tabData.sections.map((section, sectionIndex) => {
                if (!readOnly && section.type === "button" && Array.isArray(section.cta)) {
                  const hasHalfVariant = section.cta.some(ctaItem => ctaItem.variant?.includes("-half"));
                  const Wrapper = hasHalfVariant ? Flex : Box;
                  const wrapperProps = hasHalfVariant ? { justify: "space-between", gap: 4, width: "100%" } : {};

                  return (
                    <Wrapper key={`btns-wrapper-${tabIndex}-${sectionIndex}`} {...wrapperProps}>
                      {section.cta.map((ctaItem, btnIndex) => (
                        <ButtonComponent
                          key={`cta-${tabIndex}-${btnIndex}`}
                          action={ctaItem.action}
                          label={ctaItem.label}
                          ariaLabel={ctaItem.ariaLabel}
                          tooltip={ctaItem.tooltip}
                          variant={ctaItem.variant || "solid"}
                          icons={ctaItem.icons}
                          onClick={() => handleButtonAction(ctaItem.action, ctaItem)}
                          textDecoration={ctaItem.textDecoration}
                          isTouchDevice={isTouchDevice}
                          isMouseDevice={isMouseDevice}
                        />
                      ))}
                    </Wrapper>
                  );
                }

                return (
                  <ComponentFactory
                    key={`section-${tabIndex}-${sectionIndex}`}
                    section={section}
                  />
                );
              })
            ) : (
              <div>No content for this tab</div>
            )}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default TabsComponent;
